const cards = [
  {
    icon: 'https://res.cloudinary.com/damiraph/image/upload/v1765902564/Value_prop_3_cbewm7.png',
    title: 'No more roll calls',
    body: "Check-in takes seconds, not minutes. Every member has a personal QR code that marks them present the moment it's scanned.",
  },
  {
    icon: 'https://res.cloudinary.com/damiraph/image/upload/v1765902564/Value_prop_1_eixshc.png',
    title: 'Built to scale',
    body: '50 people or 50,000 members — the same app handles it all. Create unlimited groups, sub-teams and departments.',
  },
  {
    icon: 'https://res.cloudinary.com/damiraph/image/upload/v1765902564/Value_prop_2_c2cru0.png',
    title: 'Never lose a record',
    body: 'Attendance saves automatically, syncs in real time, and stays in your dashboard forever. Export any time.',
  },
];

export default function ValueProps() {
  return (
    <section className="bg-gray-50 py-24 px-6 lg:px-8 border-y border-gray-100">
      <div className="max-w-6xl mx-auto">

        {/* Header */}
        <div className="text-center mb-16">
          <p
            className="text-xs font-semibold text-[#2228B6] uppercase tracking-widest mb-4"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Why Inked
          </p>
          <h2
            className="text-4xl sm:text-5xl font-extrabold text-gray-900 mb-4"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Track attendance at{' '}
            <span style={{ color: '#2228B6' }}>lightning speed</span>
          </h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Save hours every week with automatic tracking that just works.
          </p>
        </div>

        {/* 3-column cards */}
        <div className="grid sm:grid-cols-3 gap-5">
          {cards.map((card) => (
            <div
              key={card.title}
              className="rounded-2xl border border-gray-200 bg-white p-8 hover:shadow-md transition-shadow group"
            >
              <img src={card.icon} alt={card.title} className="w-12 h-12 object-contain mb-6" />
              <h3
                className="text-lg font-bold text-gray-900 mb-2"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                {card.title}
              </h3>
              <p className="text-sm text-gray-500 leading-relaxed" style={{ fontFamily: 'Manrope, sans-serif' }}>
                {card.body}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
